import React, { memo } from 'react';

const FilterIcon = function (props) {
  return (
    <svg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        key='0'
        d='M3.83333 14.375H10.5833C10.9167 15.8625 12.25 17 13.8333 17C15.4167 17 16.6667 15.8625 17.0833 14.375H17.1667C17.6667 14.375 18 14.025 18 13.5C18 12.975 17.6667 12.625 17.1667 12.625H17.0833C16.75 11.1375 15.4167 10 13.8333 10C12.25 10 11 11.1375 10.5833 12.625H3.83333C3.33333 12.625 3 12.975 3 13.5C3 14.025 3.33333 14.375 3.83333 14.375ZM13.8333 11.75C14.75 11.75 15.5 12.5375 15.5 13.5C15.5 14.4625 14.75 15.25 13.8333 15.25C12.9167 15.25 12.1667 14.4625 12.1667 13.5C12.1667 12.5375 12.9167 11.75 13.8333 11.75Z'
        fill='#222222'
      />
      ,
      <path
        key='1'
        d='M3.83333 7.375H3.91667C4.25 8.8625 5.58333 10 7.16667 10C8.75 10 10 8.8625 10.4167 7.375H17.1667C17.6667 7.375 18 7.025 18 6.5C18 5.975 17.6667 5.625 17.1667 5.625H10.4167C10.0833 4.1375 8.75 3 7.16667 3C5.58333 3 4.33333 4.1375 3.91667 5.625H3.83333C3.33333 5.625 3 5.975 3 6.5C3 7.025 3.33333 7.375 3.83333 7.375ZM7.16667 4.75C8.08333 4.75 8.83333 5.5375 8.83333 6.5C8.83333 7.4625 8.08333 8.25 7.16667 8.25C6.25 8.25 5.5 7.4625 5.5 6.5C5.5 5.5375 6.25 4.75 7.16667 4.75Z'
        fill='#222222'
      />
    </svg>
  );
};

export default memo(FilterIcon);
